import Content from "../../common/Content";
import Button from "../../ui/Button";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg";
import DifficultySelector from "../../ui/DifficultySelector";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import FingerSkillsLevel from "../FingerSkills/FingerSkillsLevel";
import ContentCenter from "../../ui/ContentCenter";
import ArmsUpLevel from "../ArmsUp/ArmsUpLevel";
import ScrambleLevel from "../Scramble/ScrambleLevel";
import { sample, without } from "lodash";
import CrosswordLevel from "./CrosswordLevel";

export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [seed, setSeed] = useState(0);

  useEffect(() => {
    setStarted(false);
  }, [level]);

  const startGame = () => {
    setStarted(true);
    setGameOver(false);
  };

  return (
    <>
      <GameArea game={game} showDetail={!gameOver}>
        <CrosswordLevel seed={seed} setGameOver={setGameOver} level={level} disabled={!started} />
      </GameArea>

      <Content>
        <div>
          {started ? (
            <PlayButton onClick={() => setSeed(seed + 1)}>
              Neue Buchstabenanordnung
            </PlayButton>
          ) : (
            <PlayButton onClick={startGame} />
          )}
        </div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setLevel(level);
          }}
          levels={2}
          current={level}
        />
      </Content>
    </>
  );
};
